import { crudActions } from "./CrudActions"

export default {
  ...crudActions("qualitats-fisiques-basiques"),
}
